import { render, staticRenderFns } from "./HandbookCategoryList.vue?vue&type=template&id=a97dd500&scoped=true"
import script from "./HandbookCategoryList.vue?vue&type=script&lang=ts"
export * from "./HandbookCategoryList.vue?vue&type=script&lang=ts"
import style0 from "./HandbookCategoryList.vue?vue&type=style&index=0&id=a97dd500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97dd500",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VList,VListItem,VListItemContent,VListItemTitle,VTextField})
